import type {Recipe} from './types';

export const tiramisu: Recipe = {
    id: 8,
    key: "tiramisu",
    pictures: [
        {index: 0, url: "https://www.giallozafferano.it/images/251-25105/Tiramisu-della-tradizione_450x300.jpg"},
        {index: 7, url: "https://ricette.giallozafferano.it/images/ricette/262/26229/pate-a-bombe_6.jpg"},
        {index: 11, url: "https://ricette.giallozafferano.it/images/ricette/251/25105/tiramisu-della-tradizione_12.jpg"},
    ],
    i18n: {
        IT: {
            title: "Tiramisù",
            servings: "6 porzioni",
            ingredients: [
                "4 uova",
                "400 gr di mascarpone",
                "120 gr di zucchero",
                "400 gr di savoiardi",
                "2 caffè lunghi",
                "1 bustina di cacao",
            ],
            steps: [
                "Fare il caffè lungo (meglio con la moka) e mettere zucchero quanto basta se i savoiardi non sono già zuccherati in superficie",
                "Portare il mascarpone a temperatura ambiente",
                "Separare tuorli da albumi, facendo attenzione non vengano a contatto",
                "Unire metà zucchero e acqua in un pentolino in modo tale che l'acqua copra leggermente lo zucchero",
                "Mettere sul fuoco il composto e mescolare onde evitare si formi caramello ma diventi uno sciroppo",
                "Levare dal fuoco quando si vedono le bollicine bianche (ha superato i 100 gradi)",
                "Sbattere i tuorli a lungo con la frusta elettrica ad alta velocità mentre si versa a filo lo sciroppo. Continuare fino a quando si vedrà il composto addensare e schiarire",
                "Versare il composto della coppa di mascarpone a poco a poco nei tuorli in modo tale da evitare grumi (è possibile sbattere energicamente, il composto di tuorli non si smonterà)",
                "Fare nuovamente lo sciroppo con la restante metà dello zucchero",
                "Sbattere gli albumi a lungo con la frusta elettrica ad alta velocità mentre si versa a filo lo sciroppo. Gli albumi devono diventare densi a tal punto che non cadono se si rovescia la ciotola",
                "Unire il tutto rimescolando DELICATAMENTE (altrimenti il composto diventerà liquido)",
                "Mettere un po' di composto sulla base del contenitore",
                "Bagnare i savoiardi velocemente nel caffè e metterli in fila nel contenitore",
                "Coprire i savoiardi con il minimo di crema necessaria per coprirli (attenzione a non usare troppa crema)",
                "Stendere un altro strato di savoiardi",
                "Coprire con la crema restante livellando bene da coprire tutti i buchi",
                "Coprire con cacao in polvere la superficie",
                "Coprire il contenitore con pellicola trasparente e lasciare in frigo per almeno 1 ora",
            ],
        },
        EN: {
            title: "Tiramisu",
            servings: "Servings: 6",
            ingredients: [
                "4 eggs",
                "400 g of mascarpone",
                "120 g of sugar",
                "400 g of ladyfingers",
                "2 long coffees",
                "1 packet of cocoa powder",
            ],
            steps: [
                "Make long coffee (preferably with a moka pot) and add sugar as needed if the ladyfingers are not already sugared on the surface",
                "Bring the mascarpone to room temperature",
                "Separate the egg yolks from the egg whites, ensuring they do not come into contact",
                "Combine half of the sugar and enough water in a small pot so that the water slightly covers the sugar",
                "Heat the mixture, stirring constantly to prevent it from turning into caramel, until it becomes a syrup",
                "Remove from heat when white bubbles appear (the mixture has exceeded 100 degrees Celsius)",
                "Beat the egg yolks with an electric mixer at high speed while gradually pouring in the syrup in a thin stream. Continue until the mixture thickens and lightens in color",
                "Gradually add the mascarpone to the yolk mixture to avoid lumps (you can beat vigorously; the yolk mixture will not deflate)",
                "Repeat the syrup-making process with the remaining half of the sugar",
                "Beat the egg whites with an electric mixer at high speed while gradually pouring in the syrup in a thin stream. The egg whites should become so dense that they do not fall out if the bowl is turned upside down",
                "Gently fold everything together (otherwise the mixture will become liquid)",
                "Put a bit of the mixture on the bottom of the container",
                "Quickly dip the ladyfingers in the coffee and line them up in the container",
                "Cover the ladyfingers with just enough cream to cover them (be careful not to use too much cream)",
                "Lay another layer of ladyfingers",
                "Cover with the remaining cream, spreading it well to cover all gaps",
                "Dust the surface with cocoa powder",
                "Cover the container with plastic wrap and leave in the fridge for at least 1 hour",
            ],
        },
        PL: {
            title: "Tiramisu deserow",
            servings: "6 porcji",
            ingredients: [
                "4 jajka",
                "400 g mascarpone",
                "120 g cukru",
                "400 g biszkoptów typu savoiardi",
                "2 długie kawy",
                "1 saszetka kakao",
            ],
            steps: [
                "Zaparzyć długą kawę (najlepiej w kawiarce) i dodać cukru do smaku, jeśli biszkopty nie są już posypane cukrem na powierzchni.",
                "Doprowadzić mascarpone do temperatury pokojowej.",
                "Oddzielić żółtka od białek, upewniając się, że się nie zetkną.",
                "Połączyć połowę cukru z wodą w małym garnku tak, aby woda lekko przykryła cukier.",
                "Podgrzać mieszankę, stale mieszając, aby nie powstał karmel, ale syrop.",
                "Zdjąć z ognia, gdy pojawią się białe bąbelki (mieszanka przekroczyła 100 stopni Celsjusza).",
                "Długo ubijać żółtka mikserem elektrycznym na wysokich obrotach, stopniowo wlewając syrop cienkim strumieniem. Kontynuować, aż mieszanina zgęstnieje i stanie się jaśniejsza.",
                "Stopniowo dodawać mascarpone do mieszanki żółtek, aby uniknąć grudek (można energicznie ubijać, mieszanka żółtek się nie rozpadnie).",
                "Ponownie przygotować syrop z pozostałej połowy cukru.",
                "Długo ubijać białka mikserem elektrycznym na wysokich obrotach, stopniowo wlewając syrop cienkim strumieniem. Białka powinny stać się tak gęste, że nie wypadną, jeśli miska zostanie odwrócona do góry dnem.",
                "Delikatnie połączyć wszystko razem (w przeciwnym razie mieszanina stanie się płynna).",
                "Nałożyć trochę masy na dno naczynia.",
                "Szybko zamoczyć biszkopty w kawie i ułożyć je w rzędzie w naczyniu.",
                "Przykryć biszkopty minimalną ilością kremu, aby je przykryć (uważaj, aby nie użyć zbyt dużo kremu).",
                "Nałożyć kolejną warstwę biszkoptów.",
                "Przykryć pozostałym kremem, dokładnie wyrównując, aby zakryć wszystkie puste miejsca.",
                "Posypać powierzchnię kakao w proszku.",
                "Przykryć naczynie folią spożywczą i pozostawić w lodówce na co najmniej 1 godzinę.",
            ],
        },
    },
};
